import { css } from 'styled-components';

/**
 * The title type of the course result screens: Success, PassFail and the pretest results. It keeps its
 * size on phones, where the global h2 shrinks.
 */
export const resultTitle = css`
  font-family: Recoleta;
  font-size: 36px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-transform: capitalize;
`;
